import { Directive, ChangeWindow } from '../../../types';

/**
 * GPU configuration for Docker Setup Policy
 */
interface Gpu {
  id: string;
  name: string;
  memory: number;
  value: string;
}

/**
 * Form data for Docker Setup Policy
 */
export interface DockerSetupFormData {
  /** Enable host management features (CPU/memory stats, etc.) */
  enableHostManagementFeatures: boolean;
  /** Allow regular users to browse volumes */
  allowVolumeBrowserForRegularUsers: boolean;
  /** Enable GPU management support */
  enableGpuManagement: boolean;
  /** Enable image update notifications */
  enableImageNotification: boolean;
  /** List of available GPUs */
  gpus: Gpu[];
  /** GitOps change window configuration */
  changeWindow: ChangeWindow;
}

/**
 * Stored/API payload for Docker Setup Policy
 * Uses camelCase for all fields
 */
export interface DockerSetupPolicyPayload {
  enableHostManagementFeatures: Directive<boolean>;
  allowVolumeBrowserForRegularUsers: Directive<boolean>;
  enableGpuManagement: Directive<boolean>;
  enableImageNotification: Directive<boolean>;
  gpus: Directive<Gpu[]>;
  endpointChangeWindow: Directive<ChangeWindow>;
}

/**
 * Default initial values for Docker Setup Policy (create mode)
 */
export const DOCKER_SETUP_INITIAL_VALUES: DockerSetupFormData = {
  enableHostManagementFeatures: false,
  allowVolumeBrowserForRegularUsers: false,
  enableGpuManagement: false,
  enableImageNotification: false,
  gpus: [],
  changeWindow: {
    Enabled: false,
    StartTime: '22:00',
    EndTime: '02:00',
  },
};
